module.exports = __webpack_public_path__ + "img/innovation.5607620d.jpg";